import deserialize from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    item: { account: {}, order: {} }
  },

  getters: {
    currentInvoice: (state) => state.item
  },

  mutations: {
    invoiceFetched(state, { invoice }) {
      state.item = invoice
    }
  },

  actions: {
    async fetchInvoice({ commit }, params) {
      const response = await fetch({
        url: `/api/admin/accounts/${params.accountId}/invoices/${params.id}`
      })
      const invoice = await deserialize(response.data)
      commit('invoiceFetched', { invoice })
    },

    async updateInvoice({ commit, state }, changes) {
      const response = await update({
        url: `/api/admin/accounts/${state.item.accountId}/invoices/${state.item.id}`,
        patch: true,
        type: 'invoice',
        changes,
        record: state.item
      })
      const invoice = await deserialize(response.data)
      commit('invoiceFetched', { invoice })
    }
  }
}
